<template>
  <b-container>
    <Nav></Nav>
    <div v-if="showoverlay" style="z-index: 999; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
      <b-spinner style="width: 3rem; height: 3rem;" label="Please wait..."></b-spinner>
    </div>
    <b-overlay class="overspin" :show="showoverlay" rounded="sm" fixed>
      <b-row>
        <b-col>
          <h4 style="text-align: center;">Add new Vendor / User</h4>
        </b-col>
      </b-row>

      <b-form @submit="onSubmit">
        <b-row class="mt-2">
          <b-col>Vendor Name:
            <b-form-input id="vendor-name" v-model="vendorname"></b-form-input>
            <b-form-text id="vendor-name">Input here to add a new Vendor</b-form-text>
          </b-col>
        </b-row>

        <b-row class="mt-2"><b-col>--OR--</b-col></b-row>

        <b-row class="mt-2">
          <b-col>Existing Vendor:
            <b-form-select id="vendor-select" v-model="existVendorId" :options="allVendors" value-field="id" text-field="name"></b-form-select>
            <b-form-text id="vendor-select">Select a vendor to add a user to it</b-form-text>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col>User: First Name</b-col>
          <b-col>Last Name</b-col>
        </b-row>
        <b-row>
          <b-col><b-form-input id="user-fname" v-model="userfname"></b-form-input></b-col>
          <b-col><b-form-input id="user-lname" v-model="userlname"></b-form-input></b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>User ID:
          <b-form-input id="user-id" v-model="userid"></b-form-input></b-col>
        </b-row>
        <b-row>
          <b-button class="mt-4 ml-3" type="submit" variant="primary">Submit</b-button>
          <b-button class="mt-4 ml-4" variant="outline-primary" @click="clearForm()">Clear</b-button>
        </b-row>
      </b-form>

      <div  v-if="existVendorId!=0">
        <b-row class="mt-5">
          <b-col>User list for {{ this.currentVendor.name }}:</b-col>
        </b-row>
        <b-list-group>
          <b-list-group-item
            v-for="user in userList"
            :key="user.id"
          >
          {{ user.first_name }} {{ user.last_name }} - {{ user.user_account_id }}
        </b-list-group-item>
        </b-list-group>
      </div>

    </b-overlay>
  </b-container>
</template>

<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
export default {
  name: 'Onboard',
  components: {
    Nav
  },
  data() {
    return {
      showoverlay: false,
      vendorname: '',
      userfname: '',
      userlname: '',
      userid: '',
      vendor: [{id:1}],
      existVendorId: 0,
      allVendors: [],
      userList: []
    }
  },

  watch: {
    existVendorId: function() {
      this.retrieveUsers()
    }
  },

  computed: {
    currentVendor: function() {
      return this.allVendors.find(v=>v.id==this.existVendorId)
    }
  },

  methods: {

    clearForm() {
      this.vendorname = ''
      this.userfname = ''
      this.userlname = ''
      this.userid=''
      this.existVendorId=0
    },

    onSubmit(evt) {
      evt.preventDefault();
      this.createNewVendor();
    },

    async createNewVendor() {
      this.showoverlay = true;
      if (this.existVendorId!=0) {
        this.createNewUser(this.existVendorId)
      } else {
        // Get the access token from the auth wrapper
        const token = await this.$auth.getTokenSilently();

        var config = {
          headers: {
            Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
          }
        };
        var body = {
          "name": this.vendorname,
          "industry_id": 1,
          "currency": "usd",
          "country_code": 1,
          "timezone": "America/Chicago"
        }
        // update order with status of 'ready'
        const { data } = await this.$api.post('vendors',
          body,
          config
        );
        if (data.created == true) {
          this.createNewUser(data.new_vend_id);
        } else {
          this.showoverlay = false;
          this.$bvModal.msgBoxOk('There was a problem creating the vendor, please contact support.', {
            title: 'Error creating vendor',
            centered: true
          })
        }
      }
    },

    async createNewUser(vendor_id) {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = {
        "first_name": this.userfname,
        "last_name": this.userlname,
        "user_account_id": this.userid,
        "job_title": "Owner"
      }
      // update order with status of 'ready'
      const { data } = await this.$api.post('vendors/'+vendor_id+'/users',
        body,
        config
      );
      if (data.created == true) {
        this.showoverlay = false;
        this.$bvModal.msgBoxOk('Vendor and User created successfully. Login again using the new user to complete setup.', {
          title: 'Success!',
          centered: true
        })
        this.vendorname=''; this.userfname=''; this.userlname=''; this.userid='';
      } else {
        this.showoverlay = false;
        this.$bvModal.msgBoxOk('There was a problem creating the user, please contact support.', {
          title: 'Error creating user',
          centered: true
        })
      }
    },

    async retrieveVendors() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      // update order with status of 'ready'
      const { data } = await this.$api.get('vendors', config);
      if (data.success==true) {
        this.allVendors = data.vendors
      }
    },

    async retrieveUsers() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      // update order with status of 'ready'
      const { data } = await this.$api.get('vendors/'+this.existVendorId+'/users', config);
      if (data.success==true) {
        this.userList = data.users
      }
    }

  },

  created() {
    this.retrieveVendors()
  }

}
</script>
